var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMustExist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_179020",
    "data-name": "Group 179020",
    transform: "translate(-310.153 -234)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29559",
    "data-name": "Path 29559",
    d: "M6,0A6,6,0,1,1,0,6,6,6,0,0,1,6,0Z",
    transform: "translate(310.153 234)",
    fill: "#d1e6e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic_check_24px",
    d: "M5.317,9.2,3.894,7.777l-.484.481,1.907,1.907L9.41,6.071,8.929,5.59Z",
    transform: "translate(309.743 232.123)",
    fill: "#1e1e1e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMustExist);
export default __webpack_public_path__ + "static/media/MustExist.73665c5df29a7d7186669055b2f9ffe6.svg";
export { ForwardRef as ReactComponent };